import { eventAjaxDisplayCmsModal } from '../common.js';

$(document).ready(function() {
    eventAjaxDisplayCmsModal('#checkout-payment-step .legal-text a');
    movePsCheckoutPaypalBtnsInCheckout();
});

function movePsCheckoutPaypalBtnsInCheckout() {
    if ($('body#checkout').length <= 0) {
        return;
    }

    if ($('#checkout-payment-step.js-current-step') <= 0) {
        return;
    }

    let intervalPaypal = null;

    intervalPaypal = setInterval(function () {

        let hasFoundPaypalBtns = false;

        if ($('.js-payment-ps_checkout-paypal').length > 0 && $('.ps_checkout-payment-option .ps_checkout-mark[data-funding-source="paypal"]').length > 0) {
            let paypalElem = $('.ps_checkout-payment-option .ps_checkout-mark[data-funding-source="paypal"]');
            let pliciElem = paypalElem.closest('.checkout-option__main-container');

            if (pliciElem.length > 0) {
                pliciElem.append($('.js-payment-ps_checkout-paypal'));
                hasFoundPaypalBtns = true;
            }
        }

        if ($('.js-payment-ps_checkout-paylater').length > 0 && $('.ps_checkout-payment-option .ps_checkout-mark[data-funding-source="paylater"]').length > 0) {
            let paylaterElem = $('.ps_checkout-payment-option .ps_checkout-mark[data-funding-source="paylater"]');
            let pliciElem = paylaterElem.closest('.checkout-option__main-container');

            if (pliciElem.length > 0) {
                pliciElem.append($('.js-payment-ps_checkout-paylater'));
                hasFoundPaypalBtns = true;
            }
        }

        if (hasFoundPaypalBtns) {
            clearInterval(intervalPaypal);
        }

        
    }, 1000);
}
